import { createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { deleteData, getData, postData, putData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";

export const createTemplate = createAsyncThunk(
    "admin/createTemplate",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await postData(`/templates/create-template`, data);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);
export const fetchTemplates = createAsyncThunk(
    "admin/fetchTemplates",
    async (filters, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await getData(`/templates/get-templates?filters=${filters}`);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);
export const updateTemplate = createAsyncThunk(
    "admin/updateTemplate",
    async ({ id, data }, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await putData(`/templates/update-template?id=${id}`, data);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteTemplate = createAsyncThunk(
    "admin/deleteTemplate",
    async (id, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await deleteData(`/templates/delete-template?id=${id}`);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);


export const fetchTemplateAndSignatureStats = createAsyncThunk(
    "admin/fetchTemplateAndSignatureStats",
    async (filters, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await getData(`/templates/get-status`);
            return res?.data;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);



